var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 57,
    viewBox: "0 0 86 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58723 10.2834C19.1151 3.02814 63.8796 4.38694 74.9989 10.8338C88.5874 18.6593 88.3769 47.8042 74.2853 53.1997C62.2009 57.8167 25.8811 58.987 9.91579 52.3814C-2.55873 47.1843 -0.772261 18.1684 9.58723 10.2883V10.2834Z",
    fill: "#FB9306"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58723 5.88443C19.1151 -1.37078 63.8796 -0.0119872 74.9989 6.43489C88.5873 14.2604 87.9302 44.1442 74.2853 48.8008C62.8067 52.7284 25.8811 54.5881 9.91579 47.9825C-2.55873 42.7853 -0.772261 13.7695 9.58723 5.88939V5.88443Z",
    fill: "#FEC400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8002 52.8524C29.7364 52.8524 17.4159 51.6276 9.71042 48.4389C5.1005 46.5197 2.00498 41.3572 0.993673 33.9135C-0.70553 21.357 3.86332 9.60383 9.26381 5.49271C14.5 1.50556 29.4592 0.310403 41.7027 0.523646C56.7953 0.78648 69.968 2.93877 75.2607 6.00848C83.4179 10.7048 86.1284 22.6662 85.1889 31.796C84.2649 40.7621 80.2556 47.2982 74.4547 49.2769C68.4792 51.3201 55.3066 52.8574 41.8002 52.8574V52.8524ZM38.6431 1.48079C26.107 1.48079 14.2844 2.94871 9.91064 6.27629C4.10973 10.6899 0.572727 23.0282 2.02552 33.7796C2.98549 40.8662 5.86026 45.741 10.1211 47.5164C26.2507 54.1914 62.9299 52.1482 74.1159 48.3247C79.5266 46.4799 83.2844 40.2612 84.1673 31.6918C85.076 22.8695 82.5092 11.3395 74.737 6.86143C68.9053 3.48426 53.2891 1.47582 38.6482 1.47582L38.6431 1.48079Z",
    fill: "#FEF102"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M10.4804 12.6836C8.99165 10.4372 14.9414 7.35755 25.419 5.82022C37.3134 4.05972 53.9615 5.51277 64.3518 7.07985C72.3653 8.28988 74.5675 11.2653 68.4535 10.2685C52.1904 7.62037 36.1635 7.43193 28.0474 10.5859C17.0154 14.8706 12.4825 15.8129 10.4752 12.6836H10.4804Z",
    fill: "url(#paint0_linear_713_4491)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M10.8809 8.51266C9.39213 6.15212 21.7023 3.89566 22.5648 5.36357C23.4272 6.83147 11.964 10.1095 10.8809 8.51266Z",
    fill: "#FFF6AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M24.7671 5.03636C24.9468 2.93865 32.5136 3.03781 32.334 4.33711C32.1543 5.6364 24.6491 6.46459 24.7671 5.03636Z",
    fill: "#FFF6AE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_4491",
    x1: 10.2425,
    y1: 9.77704,
    x2: 71.9741,
    y2: 9.77704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE97F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBtn);
export default __webpack_public_path__ + "static/media/no_btn.ff074cb0d913f80c77087556ac49ccbc.svg";
export { ForwardRef as ReactComponent };